<form #promotionForm="ngForm">
  <section class="form promotion" [hidden]="isCreated">
    <div class="picture">
      <img src="assets/v2m-logo.svg" />
    </div>
    <div class="text">
      <h2>Umwandeln einer Schulungsversion</h2>
      <p>
        Sie haben die Möglichkeit, eine aktive Schulungs-Version in eine
        Voll-Version mit 2 Monaten Laufzeit zu verlängern.
      </p>
      <p>
        Füllen Sie dazu bitte das Formular aus. Wir schicken Ihnen dann eine
        E-Mail mit Ihrer neuen Lizenznummer.
      </p>
    </div>
    <div class="licensekey">
      <input
        type="text"
        class="form-control"
        placeholder="Vorhandene Lizenznummer"
        id="licensekey"
        name="licensekey"
        [(ngModel)]="licensekey"
        [disabled]="isCreating || isCreated"
        required
      />
    </div>
    <div class="salutation">
      <select
        class="form-control"
        id="salutation"
        name="salutation"
        [(ngModel)]="salutation"
        [disabled]="isCreating || isCreated"
      >
        <option value="" disabled>Anrede</option>
        <option value="Frau">Frau</option>
        <option value="Herr">Herr</option>
      </select>
    </div>
    <div class="lastname">
      <input
        type="text"
        class="form-control"
        placeholder="Nachname"
        id="lastname"
        name="lastname"
        [(ngModel)]="lastname"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="firstname">
      <input
        type="text"
        class="form-control"
        placeholder="Vorname"
        id="firstname"
        name="firstname"
        [(ngModel)]="firstname"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="email">
      <input
        type="email"
        class="form-control"
        placeholder="E-Mail-Adresse"
        id="email"
        name="email"
        [(ngModel)]="email"
        [disabled]="isCreating || isCreated"
        required
      />
    </div>
    <div class="company">
      <input
        type="text"
        class="form-control"
        placeholder="Firma"
        id="company"
        name="company"
        [(ngModel)]="company"
        [disabled]="isCreating || isCreated"
      />
    </div>
    <div class="privacy">
      <input
        type="checkbox"
        id="privacy"
        name="privacy"
        [(ngModel)]="privacy"
        [disabled]="isCreating || isCreated"
        required
      />
      <label for="privacy"
        >Ich erkenne den <a [routerLink]="['/privacy']">Datenschutz</a> an.
        *</label
      >
    </div>
    <div class="newsletter">
      <input
        type="checkbox"
        id="newsletter"
        name="newsletter"
        [(ngModel)]="newsletter"
        [disabled]="isCreating || isCreated"
      />
      <label for="newsletter">Ich möchte den Newsletter bestellen.</label>
    </div>

    <div class="send">
      <button
        class="send"
        (click)="send()"
        [disabled]="!promotionForm.form.valid || isCreating || isCreated"
      >
        Absenden
      </button>
    </div>

    <div class="hint">
      <p>* Pflichtfelder</p>
    </div>
  </section>
  <section class="promotion form" [hidden]="!isCreated">
    <div class="picture">
      <img src="assets/v2m-logo.svg" />
    </div>
    <div class="text">
      <h2>Umwandeln einer Schulungsversion</h2>
      <p>
        Vielen Dank. Wir haben Ihre Anforderung erhalten und werden Sie
        kurzfristig bearbeiten.
      </p>
      <p>
        Sie erhalten Ihre neue Lizenznummer per E-Mail.
      </p>
    </div>
    <div class="send">
      <button class="send" (click)="gotoHome()">Zurück zur Startseite</button>
    </div>
  </section>
</form>
